import React from "react";
import NextHead from "../../components/Seo/NextHead";
import Layout from "../../components/Layout";
import BreadcrumbComponent from "../../components/UserInterface/BreadcrumbComponent";
import { defaultURL, myHomecreditMeta } from "../../data/DataMetatags";
import { panduanKonsumenBreadcrumb } from "../../data/DataBreadcrumb";
import BannerComponent from "../../components/UserInterface/BannerComponent";
import { DataHomeCreditApp } from "../../data/DataProcedure";
import { StepsComponent } from "../../components/UserInterface/StepsComponent";
import MyhomecreditApp from "../../../public/static/images/png/my-homecredit-app.png";
import BenefitMyhomecreditApp from "../../../public/static/images/png/benefit-myhomecredit-app.png";
import BannerMyhomecreditApp from "../../../public/static/images/svg/banner_myhomecredit_app.svg";
import LayoutCenter from "../../components/UserInterface/LayoutCenter";
import VideoComponent from "../../components/UserInterface/VideoComponent";
const myHomecredit = ({ pageTitle, descriptionSEO, asPath }) => {
  const breadcrumb = [
    {
      "@type": "ListItem",
      position: "1",
      item: {
        "@id": defaultURL,
        name: "Home"
      }
    },
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": defaultURL + asPath,
        name: pageTitle
      }
    }
  ];

  const myHomecreditBreadcrumb = [
    ...panduanKonsumenBreadcrumb,
    {
      page: pageTitle,
      href: asPath,
      to: asPath
    }
  ];

  return (
    <Layout>
      <NextHead
        title={pageTitle}
        description={descriptionSEO}
        url={asPath}
        breadcrumb={breadcrumb}
      ></NextHead>
      <BreadcrumbComponent items={myHomecreditBreadcrumb}></BreadcrumbComponent>
      <BannerComponent visible img={BannerMyhomecreditApp}></BannerComponent>
      <LayoutCenter marginMobile="24px 16px" margin="60px 0 0 0">
        <StepsComponent
          showButtonApp
          appStoreLink="https://apps.apple.com/id/app/my-home-credit-indonesia/id1313113736"
          googlePlayLink="https://play.google.com/store/apps/details?id=id.co.myhomecredit&hl=in"
          displayMobile
          img={MyhomecreditApp}
          title={DataHomeCreditApp && DataHomeCreditApp.download.title}
          subtitle={DataHomeCreditApp && DataHomeCreditApp.download.desc}
        ></StepsComponent>
      </LayoutCenter>
      <VideoComponent
        maxWidth="100%"
        headingText="Download Sekarang!"
        src="https://www.youtube.com/embed/7efItnEuOCU"
      ></VideoComponent>
      <LayoutCenter marginMobile="24px 16px" margin="60px 0 0 0">
        <StepsComponent
          imgRight={MyhomecreditApp}
          title={DataHomeCreditApp && DataHomeCreditApp.stepsDownload.title}
          steps={DataHomeCreditApp && DataHomeCreditApp.stepsDownload.steps}
        ></StepsComponent>
      </LayoutCenter>
      <LayoutCenter margin="0 0 60px 0">
        <StepsComponent
          img={BenefitMyhomecreditApp}
          title={DataHomeCreditApp.benefitApp.title}
          steps={DataHomeCreditApp.benefitApp.steps}
        ></StepsComponent>
      </LayoutCenter>
    </Layout>
  );
};

myHomecredit.getInitialProps = ({ asPath }) => {
  const pageTitle = myHomecreditMeta.title;
  const descriptionSEO = myHomecreditMeta.description;
  return { pageTitle, descriptionSEO, asPath };
};

export default myHomecredit;
